export const sanitizeCurrencyValue = rawValue => {
  if (rawValue === '') return rawValue
  if (/^\d*\.?\d{0,2}$/.test(rawValue)) return rawValue

  return null
}

export const shouldShowError = (hasError, isEmpty, hasInvalidRange) => (hasError && isEmpty) || hasInvalidRange

export const getMinHelperText = (hasError, isEmpty) => {
  if (hasError && isEmpty) return 'Este campo es obligatorio'
}

export const getMaxHelperText = (hasError, isEmpty, hasInvalidRange) => {
  if (hasInvalidRange) return 'El valor mínimo debe ser menor que el máximo'
  if (hasError && isEmpty) return 'Este campo es obligatorio'
}
